var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    d: "m14.608 6.559 1.417 3.523 1.374-3.54C18.27 4.291 20.437 1.5 24 1.5c3.345 0 6.5 3.359 6.5 8.1 0 2.109-.857 4.482-2.295 6.942-1.427 2.44-3.35 4.842-5.31 6.975A73 73 0 0 1 16 30.068a72.75 72.75 0 0 1-6.895-6.55c-1.96-2.133-3.883-4.534-5.31-6.975C2.357 14.082 1.5 11.709 1.5 9.6c0-4.741 3.155-8.1 6.5-8.1 1.238 0 2.619.566 3.876 1.554 1.25.984 2.24 2.278 2.732 3.505Z"
  })));
};
export default SvgHeart;